module.exports = __webpack_public_path__ + "static/media/google-play-black.852374c7.svg";